import React from 'react'
import PropTypes from 'prop-types'

// Vars
import { Label } from '../../TextStyles'

// SVGs
import Pin from '../../svgs/Pin'

// Styles
import {
  MapLocationOuter,
  MapLocationWrapper,
  MapLocationImage,
  MapLocationLabel,
  MapLocationPin,
} from './index.style'

const MapLocation = ({ inView, left, top, active, delay, image, label }) => {
  return (
    <MapLocationOuter left={left} top={top} active={active} delay={delay}>
      <MapLocationWrapper inView={inView}>
        <MapLocationImage image={image} />
        <MapLocationLabel>
          <MapLocationPin>
            <Pin />
          </MapLocationPin>
          <Label>{label}</Label>
        </MapLocationLabel>
      </MapLocationWrapper>
    </MapLocationOuter>
  )
}

MapLocation.propTypes = {
  inView: PropTypes.bool,
  left: PropTypes.number,
  top: PropTypes.number,
  active: PropTypes.bool,
  delay: PropTypes.number,
  image: PropTypes.string,
}

MapLocation.defaultProps = {
  delay: 0,
}

export default MapLocation
